<!--
 * @Author: zhangjingqing
 * @Date: 2022-05-29 19:49:04
 * @LastEditors: zhangjinqing
 * @LastEditTime: 2022-08-18 21:12:22
 * @Description: file content
 * @FilePath: \lcdp-front-web\src\views\user\RegisterModal.vue
-->
<template>
  <a-modal
      title="修改密码"
      :width="800"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :maskClosable="false"
      okText="修改密码"
      @ok="handleSave"
      @cancel="handleCancel"
  >
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
      <a-descriptions title="基本信息" :column="3"> </a-descriptions>
      <a-form-item label="账号">
        <a-input
            v-decorator="[
            'contactEmail',
            {
              rules: [{ required: true,validator: this.handleAccount }],
              trigger: 'blur',
            },
          ]"
            placeholder="请输入邮箱"
        />
      </a-form-item>
      <a-popover
          placement="rightTop"
          trigger="click"
          :visible="state.passwordLevelChecked"
      >
        <template slot="content">
          <div :style="{ width: '240px' }">
            <div :class="['user-register', passwordLevelClass]">
              强度：<span>{{ passwordLevelName }}</span>
            </div>
            <a-progress
                :percent="state.percent"
                :showInfo="false"
                :strokeColor="passwordLevelColor"
            />
            <div style="margin-top: 10px">
              <span>请至少输入 8 个字符。请不要使用容易被猜到的密码。</span>
            </div>
          </div>
        </template>
        <a-form-item label="新密码">
          <a-input
              v-decorator="[
              'password',
              {
                rules: [{required: true, validator: this.handlePasswordLevel }],
                trigger: 'blur',
              },
            ]"
              type="password"
              @focus="handlePasswordInputClick(true)"
              @blur="handlePasswordInputClick(false)"
              autocomplete="new-password"
              placeholder="至少8位密码，区分大小写"
          ></a-input>
        </a-form-item>
      </a-popover>

      <a-form-item label="确认密码">
        <a-input
            v-decorator="[
            'password2',
            {
              rules: [
                { required: true, message: '确认密码不能为空' },
                { validator: this.handlePasswordCheck },
              ],
              trigger: 'blur',
            },
          ]"
            type="password"
            autocomplete="false"
            placeholder="确认密码"
        ></a-input>
      </a-form-item>
      <a-form-item label="激活码" v-if="isU8c">
        <a-input
            v-decorator="[
            'cdk',
            {
              rules: [{ required: true, message: '激活码不能为空' }],
              trigger: 'blur',
            },
          ]"
            placeholder="请输入激活码"
        />
      </a-form-item>
      <a-descriptions title="企业信息" :column="3"> </a-descriptions>
      <a-form-item label="企业名称">
        <a-input
            v-decorator="[
            'name',
            {
              rules: [{ required: true, message: '企业名称不能为空' }],
              trigger: 'blur',
            },
          ]"
            placeholder="请输入企业名称"
        />
      </a-form-item>
      <a-form-item label="纳税人识别号">
        <a-input
            v-decorator="[
            'taxpayerNo',
            {
              rules: [
                {
                  required: true,
                  message: '纳税人识别号不能为空',
                },
              ],
              trigger: 'blur',
            },
          ]"
            placeholder="请输入纳税人识别号"
        />
      </a-form-item>

    </a-form>
  </a-modal>
</template>
<script>
const levelNames = {
  0: "低",
  1: "低",
  2: "中",
  3: "强",
};
const levelClass = {
  0: "error",
  1: "error",
  2: "warning",
  3: "success",
};
const levelColor = {
  0: "#ff0000",
  1: "#ff0000",
  2: "#ff7e05",
  3: "#52c41a",
};
import pick from "lodash.pick";
import { updatePassword } from "@/api/login";
import {
  queryExtendFieldServiceList,
} from "@/api/tenant";
export default {
  name: "UpdatePasswordModal",
  data() {
    return {
      visible: false,
      form: this.$form.createForm(this, { name: "form" }),
      confirmLoading: false,
      open: false,
      state: {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: "#FF0000",
      },
      expandFields: [],
      isU8: false,
      isU8c: false,
    };
  },
  methods: {
    async show() {
      // this.isU8 = location.host == "test-u8.hthuiyou.com";
      this.isU8 = location.host == "tax-u8.hthuiyou.com";
      // this.isU8c = location.host == "test-u8c.hthuiyou.com";
      this.isU8c = location.host == "tax-u8c.hthuiyou.com";
      await this.queryList();
      this.visible = true;
    },
    async queryList() {
      this.loading = true;
      let res = await queryExtendFieldServiceList({
        page: 1,
        pageSize: 100,
      });
      if (res.status == 200) {
        this.expandFields = res.data.rows;
      } else {
        let msg = res.msg || res.message;
        let len = msg.length;
        this.$notification.error({
          message: "系统提示",
          description: len > 100 ? "系统错误，请联系管理员" : msg,
          duration: 4,
        });
      }
      this.loading = false;
    },
    handleSave() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          let params = Object.assign(
              {},
              pick(
                  values,
                  "contactEmail",
                  "password",
                  "name",
                  "taxpayerNo"
              )
          );
          let res = await updatePassword(params);
          if (res.status == 200) {
            this.$notification.success({
              message: "系统提示",
              description: "修改密码成功，请使用新密码登录！",
              duration: 4,
            });
            this.handleCancel();
          } else {
            let msg = res.msg || res.message;
            let len = msg.length;
            this.$notification.error({
              message: "系统提示",
              description: len > 100 ? "系统错误，请联系管理员" : msg,
              duration: 4,
            });
          }
        }
      });
    },
    handleCancel() {
      this.state = {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: "#FF0000",
      };
      this.form.resetFields();
      this.visible = false;
    },
    openChange(status) {
      if (status) {
        this.open = true;
      } else {
        this.open = false;
      }
    },
    panelChange(value) {
      this.form.setFieldsValue({ since: String(value.year()) });
      this.open = false;
    },
    handleAccount(rule, value, callback) {
      if (value == "") {
        callback(new Error("账号不能为空"));
      } else {
        if (
            !new RegExp(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            ).test(value)
        ) {
          callback(new Error("请输入正确格式的邮箱!"));
        } else {
          callback();
        }
      }
    },
    handlePasswordLevel(rule, value, callback) {
      if (value == "") {
        callback(new Error("密码不能为空"));
      }
      let level = 0;
      let reg =
          /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/;
      if (!reg.test(value)) {
        callback(new Error("密码由8位数字、大小写字母和特殊符号组成!"));
      }
      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++;
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++;
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++;
      }
      this.state.passwordLevel = level;
      this.state.percent = level * 30;
      if (level >= 2) {
        if (level >= 3) {
          this.state.percent = 100;
        }
        callback();
      } else {
        if (level === 0) {
          this.state.percent = 10;
        }
        callback(new Error("密码强度不够"));
      }
    },

    handlePasswordCheck(rule, value, callback) {
      let password = this.form.getFieldValue("password");
      if (value === undefined) {
        callback(new Error("请输入密码"));
      }
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error("两次密码不一致"));
      }
      callback();
    },

    handlePasswordInputClick(flag) {
      this.state.passwordLevelChecked = flag;
    },
  },
  computed: {
    passwordLevelClass() {
      return levelClass[this.state.passwordLevel];
    },
    passwordLevelName() {
      return levelNames[this.state.passwordLevel];
    },
    passwordLevelColor() {
      return levelColor[this.state.passwordLevel];
    },
  },
};
</script>
<style lang="less" scoped>
</style>
